
export const state = {
    administration_view: 'administration', // administration or workflow
};

export const mutations = {
    setAdministrationView(state, newValue) {
        state.administration_view = newValue;
    },
};

export const actions = {
    setAdministrationView({commit}, view) {
        commit('setAdministrationView', view);
    },
};
